import APIUtils from '@spothero/utils/api';
import humps from 'lodash-humps';

const CreditAPI = {
    /* eslint-disable camelcase */
    checkPromoCode({
        email,
        price,
        promoCode: promo_code,
        ruleGroupId: rule_group_id,
        ruleType: rule_type,
        spotId: parking_spot_id,
        currencyType: currency_type,
        starts,
        ends,
    }) {
        return APIUtils.post('promocodes/check/', {
            email,
            parking_spot_id,
            price,
            promo_code,
            rule_group_id,
            rule_type,
            currency_type,
            starts,
            ends,
            /* eslint-enable camelcase */
        })
            .then(({data: {data}}) => humps(data))
            .then(data => {
                return {
                    ...data,
                    creditAmount: (data.creditAmount || 0) / 100,
                    discountAmount: (data.discountAmount || 0) / 100,
                    percentageOff: data.percentageOff || 0,
                    percentageOffDiscountMax:
                        (data.percentageOffDiscountMax || 0) / 100,
                };
            });
    },

    update(requestData) {
        const {userId, amountChanged, reason, currencyType} = requestData;

        return APIUtils.patch(
            `users/${userId}/credit/`,
            {
                currency_type: currencyType.toLowerCase(), // eslint-disable-line camelcase
                credit_delta: parseFloat(amountChanged), // eslint-disable-line camelcase
                reason,
                notify_user: false, // eslint-disable-line camelcase
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        ).then(
            ({
                data: {
                    data: {spothero_credit: credit},
                },
            }) => credit
        );
    },

    getUpdateReasons() {
        return APIUtils.get('credit-reason/');
    },
};

export default CreditAPI;
